/**
 * Cookie配置文件
 * 用于管理不同环境下的Cookie设置
 */

// 根据环境获取Cookie配置
const getCookieConfig = () => {
  const env = process.env.NODE_ENV
  const hostname = window.location.hostname

  // 从环境变量获取应用名称，如果没有设置则使用默认值
  const appName = process.env.VUE_APP_COOKIE_APP_NAME || 'ruantong_e5'

  // 开发环境配置
  if (env === 'development') {
    return {
      appName: appName,
      domain: undefined, // 本地开发不设置domain
      secure: false,
      sameSite: 'lax'
    }
  }

  // 生产环境配置
  return {
    appName: appName,
    domain: getDomainFromHostname(hostname),
    secure: process.env.VUE_APP_HTTPS === 'true', // 根据环境变量决定是否使用HTTPS
    sameSite: 'lax'
  }
}

/**
 * 从主机名获取域名
 * @param {string} hostname 主机名
 * @returns {string|undefined} 域名
 */
const getDomainFromHostname = (hostname) => {
  // 本地开发环境
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return undefined
  }
  
  // IP地址
  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return hostname
  }
  
  // 域名处理
  const parts = hostname.split('.')
  if (parts.length >= 2) {
    // 使用主域名，如 .example.com
    return '.' + parts.slice(-2).join('.')
  }
  
  return hostname
}

// 导出配置
export default getCookieConfig() 